window.OnBoardingJourneyAPI = new function () {
    const self = this;
    const _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.OnBoardingJourneyServer);

    self.getUnreadEvents = () => {
        const defer = $q.defer();

        _protected.request(`onboarding_events/unread`, 'GET')
            .then(function (res) {
                if (res.data?.data && res?.status === 200) {
                    defer.resolve(res.data.data.events);
                } else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                defer.reject(err);
            });
        return defer.promise;
    }
}